const en = {
  header: 'Manage Elections',
  menu: {
    my: 'My Elections',
    admin: 'Manage Elections'
  },
  myElections: 'Election Overview',
  noElectionsFound: 'No elections found',
  notEligibleForAnyElections: 'You are currently not eligible for any elections.',
  noActiveElections: 'No active elections found.',
  noPlannedElections: 'No planned elections found.',
  noEndedElections: 'No ended elections found.',
  total: 'total',
  perPage: 'Per page',
  election: 'Election',
  elections: 'Elections',
  edit: {
    header: 'Edit election',
    createHeader: 'Create election',
    editSuccess: 'Election was successfully edited',
    createSuccess: 'Election was successfully created',
    createFailed: 'Election could not be created',
    editFailed: 'Election could not be edited',
    editButton: 'Edit election',
    createButton: 'Create election',
    currentlyEditingButton: 'Editing...',
    currentlyCreatingButton: 'Creating...',
    cancel: 'Cancel',
    notEditableTooltip: 'Only planned elections can be edited'
  },
  info: 'All fields marked with * are required.',
  fields: {
    title: 'Title',
    description: 'Description',
    electionStartDate: 'Election start',
    electionEndDate: 'Election end',
    visibleStartDate: 'Visible from',
    visibleEndDate: 'Visible until',
    polyasProjectId: 'Polyas Project ID',
    polyasSharedSecret: 'Secret Key'
  },
  validation: {
    case1: 'The start date of the election must be before the end date.',
    case2: 'The start date of the visibility must be before the end date',
    case3: 'The start date of the visibility must be before or on the start date of the election',
    case4: 'The end date of the visibility must be after or on the end date of the election'
  },
  detail: {
    backToElectionAdmin: 'Back to election management',
    errorLoadingElection: 'The election could not be loaded. Please try again later.',
    createdBy: 'Created by',
    edit: 'Edit',
    goToElectionPage: 'Go to election page',
    electionPeriod: 'Election period',
    visibility: 'Visibility',
    voterParticipation: 'Voter participation',
    votedCount: 'have voted',
    overview: 'Overview',
    eligibleVoters: 'Eligible voters',
    description: 'Description',
    noDescription: 'No description available',
    importVoters: 'Import voters',
    importVotersDescription:
      'Import voters via CSV file. The file must contain at least an email column. Previously imported users will be overwritten.',
    manageVoters: 'Manage eligible voters',
    manageVotersDescription: 'Filter and manage registered voters.',
    delete: 'Delete election',
    deleteConfirm: 'Are you sure you want to delete this election? This action cannot be undone.',
    deleteNotAllowedTooltip:
      'Elections can only be deleted while they are not yet visible to users.',
    importNotAllowedTooltip:
      'Voters can only be imported while the election is not yet visible to users.'
  },
  voter: {
    import: {
      importing: 'Importing voters...',
      completed: 'completed',
      uploadingFile: 'Uploading file...',
      stepUpload: 'Uploading file',
      stepSearch: 'Searching for users',
      stepDuplicates: 'Detecting duplicates',
      stepSave: 'Saving data',
      bulkUploadFailedWithCause: `The import of voters failed.`,
      processingBackground: 'Processing in background...',
      processingTimeout: 'Processing took longer than expected. Please try again.',
      processingFile: 'Processing file...',
      dragCsvHere: 'Drag CSV file here',
      orClickToSelect: 'or click to select a file',
      requiredColumns: 'Required column: Email, Election group',
      errorProcessing: 'Processing error',
      fileReadError: 'Error reading file',
      onlyCsvAllowed: 'Please only upload CSV files.',
      valid: 'valid',
      invalid: 'invalid',
      faultyUsers: 'Faulty users',
      couldNotBeImported: 'Could not be imported',
      duplicateUsers: 'Duplicate users',
      duplicateUsersDescription: 'Only one user was imported for each duplicate.',
      rowA: 'Row A',
      emailA: 'Email A',
      rowB: 'Row B',
      emailB: 'Email B',
      similarity: 'Similarity (0-10)',
      status: 'Status',
      email: 'Email',
      firstName: 'First name',
      lastName: 'Last name',
      note: 'Note'
    },
    table: {
      noVoters: 'No voters available',
      addVotersHint: 'Add eligible voters to be able to hold this election.',
      votingGroups: 'Voting groups',
      voted: 'Voted',
      pending: 'Pending',
      markedAt: 'Marked at'
    },
    management: {
      voters: 'Voters',
      voted: 'voted',
      pending: 'pending',
      polyasExport: 'Polyas Export',
      searchPlaceholder: 'Search by name or email...',
      status: 'Status',
      allStatuses: 'All statuses',
      votedStatus: 'Voted',
      pendingStatus: 'Pending',
      showing: 'Showing',
      of: 'of',
      votersCount: 'voters'
    }
  },
  status: {
    all: 'All',
    active: 'Active',
    planned: 'Planned',
    finished: 'Finished'
  },
  userElection: {
    voted: 'Voted',
    electionActive: 'The election is active. Click the button to vote.',
    voteNow: 'Vote now',
    electionStartsAt: 'The election starts at',
    electionEnded: 'This election has ended. You have not voted.',
    remindersActive: 'Reminders active',
    noReminders: 'No reminders',
    markAsVoted: 'Mark as voted',
    goToVoting: 'Go to voting',
    redirectToExternal:
      'You will be redirected to the external voting platform to cast your vote. Your personalized link authenticates you automatically.',
    cancel: 'Cancel',
    goToVotingButton: 'Go to voting'
  },
  myElectionsPage: {
    pendingVotes: 'Pending votes',
    pendingVotesDescription:
      "You have {{count}} active election{{plural}} that you haven't voted on yet."
  },
  list: {
    voted: 'voted',
    edit: 'Edit'
  }
};

export default en;
export type PolyasTranslation = typeof en;
